import React, { useState } from 'react';
import CreatableSelect from 'react-select/creatable';
import { selectProps } from './OptionField';

const MAX_ID = 2147483647;
const separator = /[\s,;]+/;
const validNumber = (token) => /^\d+$/.test(token) && Number(token) >= 1 && Number(token) <= MAX_ID;
/** Números válidos de um texto digitado ou colado, somados à seleção atual sem repetir. */
export function mergeNumbers(value, text) {
  const tokens = text.split(separator).filter(Boolean);
  return {
    numbers: [...new Set([...value, ...tokens.filter(validNumber).map(Number)])],
    invalid: tokens.filter((token) => !validNumber(token)),
  };
}

/** Números digitados ou colados (separados por espaço, vírgula ou ponto e vírgula). */
export default function NumberListField({ id, label, value, onChange, onPending }) {
  const [input, setInput] = useState('');
  const [error, setError] = useState(null);
  const type = (text) => {
    setInput(text);
    onPending(text);
  };
  const add = (text) => {
    if (!text.split(separator).some(Boolean)) return;
    const { numbers, invalid } = mergeNumbers(value, text);
    if (numbers.length > 100) {
      setError('Informe até 100 números.');
      return;
    }
    onChange(numbers);
    type('');
    setError(invalid.length ? `Ignorado: ${invalid.join(', ')}. Informe apenas números.` : null);
  };
  return (
    <div className="tc-f-field" data-filter-field={id}>
      <label htmlFor={id}>{label}</label>
      <CreatableSelect
        {...selectProps}
        inputId={id}
        instanceId={id}
        aria-label={label}
        aria-describedby={error ? `${id}-error` : undefined}
        placeholder="Informe o número"
        components={{ DropdownIndicator: null, IndicatorSeparator: null }}
        menuIsOpen={false}
        inputValue={input}
        value={value.map((number) => ({ value: number, label: String(number) }))}
        onChange={(items) => onChange((items || []).map((o) => o.value))}
        onInputChange={(text, { action }) => {
          if (action !== 'input-change') return;
          setError(null);
          if (separator.test(text)) add(text);
          else type(text);
        }}
        onKeyDown={(e) => {
          if (input && ['Enter', 'Tab'].includes(e.key)) {
            if (e.key === 'Enter') e.preventDefault();
            add(input);
          }
        }}
        onBlur={() => input && add(input)}
      />
      {error && (
        <span id={`${id}-error`} role="alert" className="tc-f-search-error">
          {error}
        </span>
      )}
    </div>
  );
}
